// A mixins for authenticated user.
// Includes getters, role checking, etc.
import * as USER from '@/store/constants/user';
import {mapGetters} from 'vuex';

export default {
  data() {
    return {}
  },

  computed: {
    ...mapGetters({
      authUser: USER.GET_USER
    }),

    isDoctor() {
      return this.authUser.role.name === 'doctor';
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/authenticated-user.js